import { useEffect, useState, useCallback } from 'react';
import { getFirebaseUnreadCount } from 'wisestep-api';

import { useNotificationSSEStore } from '../components/NotificationSSE/utils/NotificationSSEStore';

export function useNotificationCount() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const setUnreadCount = useNotificationSSEStore((state) => state.setNotificationSSE);
  const unreadCount = useNotificationSSEStore((state) => state.unReadCount);

  const fetchCount = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getFirebaseUnreadCount();
      setUnreadCount(response.data);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch notification count:', err);
      setError(err instanceof Error ? err : new Error('Failed to fetch notification count'));
    } finally {
      setLoading(false);
    }
  }, [setUnreadCount]);

  useEffect(() => {
    fetchCount();

    const handleNotificationReceived = () => {
      fetchCount();
    };
    window.addEventListener('notification-received', handleNotificationReceived);

    // Listen for visibility change
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        fetchCount();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Clean up
    return () => {
      window.removeEventListener('notification-received', handleNotificationReceived);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [fetchCount]);

  return {
    count: unreadCount,
    loading,
    error,
    refresh: fetchCount,
  };
}

export default useNotificationCount;
